/**
 * Figma Node IDs:
 * Design Frame: 4022:3919
 * Instance IDs: 4022:4111, 4022:4803, 4022:4809, 4022:4827, 4022:4833, 4022:4839, 4022:4845, 4022:4851, 4022:4857, 4022:4863, 4022:4869, 4022:4875
 * Composite: true
 * Last Updated: 2024-12-23
 * Generated by: Claude Code figma-component command
 */
import * as React from "react";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import * as styles from "./Heading.css";

export type HeadingSize =
  | "xxxl"
  | "xxl"
  | "xl"
  | "l"
  | "m"
  | "s"
  | "xs"
  | "xxs";
export type HeadingVariant = "default" | "alt";
export type HeadingElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export interface HeadingProps {
  size: HeadingSize;
  children: React.ReactNode;
  variant?: HeadingVariant;
  className?: string;
}

/**
 * Heading component for displaying text with different size and font variants.
 * Supports both standard (Bio Sans) and alternative (Bebas Neue) font families.
 */
// Map heading sizes to semantic HTML elements
const SIZE_TO_ELEMENT: Record<HeadingSize, HeadingElement> = {
  xxxl: "h1",
  xxl: "h1",
  xl: "h2",
  l: "h3",
  m: "h4",
  s: "h5",
  xs: "h6",
  xxs: "h6",
};

export const Heading = ({
  size,
  children,
  variant = "default",
  className,
}: HeadingProps) => {
  // Default semantic heading level based on size
  const Element = SIZE_TO_ELEMENT[size] ?? "h2";

  // Determine the style variant key
  const styleKey =
    variant === "alt" && ["xxxl", "xxl", "xl", "l"].includes(size)
      ? `${size}_alt`
      : size;

  const headingClassName =
    `${styles.heading[styleKey as keyof typeof styles.heading]} ${
      className || ""
    }`.trim();

  return (
    <Element className={headingClassName}>
      <RichText value={children} />
    </Element>
  );
};
